import { useJsApiLoader } from '@react-google-maps/api';

/**
 * Google Maps全体のJavaScriptファイルの読み込みに関するカスタムフック。
 * @returns isLoaded - Google Mapsスクリプトの読み込みが完了したかを表すフラグ。
 * @returns loadError - Google Mapsスクリプトの読み込みでエラーが発生した場合のエラー情報。
 */
export function useGoogleMaps() {
  /** リクエストパラメーター。 */
  const searchParams = new URLSearchParams(window.location.search);
  /** 言語設定。 */
  const lang = searchParams.get('lang') || 'ja';
  /** GOOGLE MAPS APIのキー。（環境変数から参照する。） */
  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY as string;
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_API_KEY,
    language: lang,
  })
  return { isLoaded, loadError }
}
